<template>
  <div class="w100 asideMain" id="areaTree">
    <div class="wBtn">
      <!-- 写信 -->
      <span class="writeEmail" @click="writeEmail">
        <i class="el-icon-edit"></i>{{$t('newMail')}}</span>
      <!-- 新建会议 -->
      <span class="newMeeting" @click="newMeetingEmailFn">{{$t('newMeeting')}}</span>
    </div>
    <div id="rMenu" ref="rMenu">
      <ul>
        <!-- 新建文件夹 -->
        <li v-show="rightMenuShowSet.m_add" @click="addFolder">{{$t('createNewFolder')}}</li>
        <!-- 清空文件夹 -->
        <li v-show="rightMenuShowSet.m_clear" @click="clearFolder">{{$t('emptyFolder')}}</li>
        <!-- 全部标记为已读 -->
        <li v-show="rightMenuShowSet.m_marked" @click="markedFolder">{{$t('markAllAsRead')}}</li>
        <!-- 查看未读 -->
        <li v-show="rightMenuShowSet.m_unread" @click="viewUnread">{{$t('viewUnread')}}</li>
        <!-- 重命名 -->
        <li v-show="rightMenuShowSet.m_editFile" @click="editFolder">{{$t('rename')}}</li>
        <!-- 删除 -->
        <li v-show="rightMenuShowSet.m_delete" @click="deleteFolder">{{$t('delete')}}</li>
        <!-- 规则设置 -->
        <li v-show="rightMenuShowSet.m_class" @click="ruleSetDialogVisibility = true">{{$t('createRules')}}</li>
      </ul>
    </div>
    <el-tree ref="emailFolderTree" v-show="!showCalendar" :data="treeData" node-key="Id" :highlight-current="true" :expand-on-click-node="false" :props="treeProps" :empty-text="treeTipText" :default-expanded-keys="defaultExpandNodeKeys" :auto-expand-parent="true" @node-click="treeNodeClick" @node-expand="treeNodeExpand" @node-collapse="treeNodeCollapse" @node-contextmenu="treeNodeContextmenu"></el-tree>
    <!--日历-->
    <div class="calendar" v-if="showCalendar">
      <Calendar ref="calendar" :sundayStart="true" v-on:isToday="clickToday" v-on:choseDay="choseDay" v-on:changeMonth="changeMonth">
      </Calendar>
    </div>
    <!--规则设置-->
    <el-dialog :title="$t('createRules')" :visible.sync="ruleSetDialogVisibility" @close="resetRule()" width="500px">
      <el-form :form="ruleSetInfo" label-width="120px">
        <!-- 满足所选条件 -->
        <div class="fb">{{$t('meetingSelectCondition')}}</div>
        <!--<el-checkbox>beixi</el-checkbox>-->
        <!-- 主题包含 -->
        <el-form-item :label="$t('subjectContains')">
          <el-input v-model="ruleSetInfo.Subject"></el-input>
        </el-form-item>
        <!-- 发件人包含 -->
        <el-form-item :label="$t('senderContains')">
          <!-- 请输入邮箱地址 -->
          <el-input v-model="ruleSetInfo.Sender" :placeholder="$t('pleaseInputEmailAddress')"></el-input>
        </el-form-item>
        <!-- 执行下列操作 -->
        <div class="fb">{{$t('performFllowOperations')}}</div>
        <!-- 移动至 -->
        <el-form-item :label="$t('moveTo')">
          <el-input v-model="editFileName" readonly></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="ruleSetFn('取消')">{{$t('cancel')}}</el-button>
        <!-- 确定 -->
        <el-button type="primary" @click="ruleSetFn('确定')">{{$t('confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import NotificationIcon from "@/assets/icon-notification.png"
import Calendar from "@/page/calendar/calendar"
export default {
  name: "areaTree",
  components: {
    Calendar
  },
  data() {
    return {
      // 是否接收消息提醒
      acceptNotification: false,
      // 收件箱未读邮件数量
      inboxUnreadNum: 0,
      startGetRoots: false, //是否在获取根目录
      // 树数据
      treeData: [],
      // 树内容为空时的提示
      treeTipText: "目录加载中...",
      // 树节点属性配置
      treeProps: {
        label: "name",
        children: "ChildFolders",
        disabled: false,
        // 如果没有子元素，则为叶子节点
        isLeaf: (data, node) => {
          return !data.ChildFolderCount
        }
      },
      // 默认展开的节点
      defaultExpandNodeKeys: [],
      // 所有展开过的节点
      expandNodeKeys: {},
      // 右键菜单功能显示控制
      rightMenuShowSet: {
        m_add: false,
        m_marked: true,
        m_unread: true,
        m_clear: true,
        m_editFile: false,
        m_delete: false,
        m_class: false
      },
      // 右键所在的节点
      rightClickTreeNode: null,
      // 草稿箱目录Id
      draftsFolderId: undefined,
      // 已删除目录Id
      deletedFolderId: undefined,

      zNodes: "",
      treeArrName: [],
      pId: "", //该节点id
      editFileName: "", //重命名名字
      isParent: false, //是否有父级
      level: "", //层级
      isOneNode: false,
      emailID: "",
      ruleSetDialogVisibility: false, //规则设置弹窗显示、隐藏
      ruleSetInfo: {
        Subject: "", //主题
        Sender: "" //发件人
      },
      btnclick: "", //点击写信、会议按钮（c3环境中用于改变边框颜色）
      inboxId: "", //收件箱id
      inboxObj: {} //收件箱文件夹数据对象
    }
  },
  beforeMount() {},
  computed: {
    //显示隐藏日历
    showCalendar() {
      const routerName = this.$route.name
      if (routerName == "CalendarView") {
        return true
      } else {
        return false
      }
    },
   
    // 当前使用语言
    c3Locale() {
      return this.$store.state.Site.locale
    }
  },
  watch: {
    "$route.query.folderId": function(newVal, oldVal) {
      if (newVal) {
        // 刷新时根据路由信息定位选中左侧目录
        let folderTree = this.$refs.emailFolderTree
        if (folderTree) {
          folderTree.setCurrentKey(newVal)
        }
      }
    }
  },
  methods: {
    //文件夹目录
    getAllFolderFn(type) {
      // 文件夹数据重置为空数组，否则手动刷新时没有加载效果
      this.treeData = []
      this.$api.get(
        `/${this.$utils.getApiPrefix().exchangeapi}/folders`,
        {},
        r => {
          if (r.Success) {
            let tempData = r.Data
            //根目录文件夹数量显示处理
            tempData.forEach((item, index) => {
              //只有草稿箱根目录是显示 名称+总数，其他目录节点都是显示 名称+未读数
              // 草稿箱FolderType = 2
              if (item.FolderType === 2) {
                if (item.TotalCount > 0) {
                  item.name = item.DisplayName + "(" + item.TotalCount + ")"
                } else {
                  item.name = item.DisplayName
                }
              } else {
                item = this.formatTreeNodeName(item)
              }
              // 默认展开收件箱,收件箱的FolderType = 1
              if (item.FolderType === 1) {
                //收件箱id赋值
                this.inboxId = item.Id
                //收件箱文件夹数据对象
                this.inboxObj = item

                this.defaultExpandNodeKeys.push(item.Id)
                this.expandNodeKeys[item.Id] = true
                //首次进入时点击收件箱目录
                if (type === "firstLoad") {
                  this.treeNodeClick(item, {level: 1})
                }
                // 轮询时
                if (type === "polling") {
                  if (item.UnreadCount && item.UnreadCount != this.inboxUnreadNum) {
                    this.popNotification(item.UnreadCount)
                  }
                  // 在folder页面时
                  if (this.$route.name === "folderList") {
                    this.$root.$emit("refreshFolderPage", item.ChildFolders)
                  }
                }
                // c3环境---切换左侧菜单到邮箱
                if (type === "activeView") {
                  this.$root.$emit("refreshFolderPage", item.ChildFolders)
                }
                // 手动刷新
                if (type === "handleRefresh") {
                  this.$root.$emit("refreshFolderPage", item.ChildFolders)
                }
                //收件箱子文件信息
                this.$store.commit("updateInboxSub", item.ChildFolders)
                // 文件箱未读数量
                this.inboxUnreadNum = item.UnreadCount                
              }
              // 保存草稿箱Id
              if (item.FolderType === 2) {
                this.draftsFolderId = item.Id
              }
              // 保存已删除目录Id
              if (item.FolderType === 4) {
                this.deletedFolderId = item.Id
              }
              // 子文件夹处理
              if (item.ChildFolders.length > 0) {
                item.ChildFolders = this.handleSubdir(item.ChildFolders)
              }
            })
            this.treeData = tempData
            this.$nextTick(() => {
              let folderTree = this.$refs.emailFolderTree
              if (!folderTree) return
              // 获取收件箱节点
              let inboxNode = folderTree.getNode(this.inboxId)
              let routerFolderId = this.$route.query.folderId
              // 如果是在列表页刷新(有目录Id)
              if (routerFolderId) {
                // 获取路由所在节点
                let routeNode = folderTree.getNode(routerFolderId)
                // 如果不是收件箱下的节点，直接设置为选中状态
                // if (routeNode && routeNode.parent && routeNode.parent != inboxNode) {
                //   folderTree.setCurrentKey(routerFolderId)
                // }
                // 设置当前所在的文件夹为选中
                folderTree.setCurrentKey(routerFolderId)
              } else {
                folderTree.setCurrentKey(this.inboxId)
              }
              // 加此代码，否则手动刷新时已展开文件夹会折叠起来
              this.defaultExpandNodeKeys = []
              Object.keys(this.expandNodeKeys).forEach((item, index, arr) => {
                this.defaultExpandNodeKeys.push(item)
              })
            })
          } else {
            this.treeTipText = "目录加载失败！"
          }
        },
        e => {
          this.treeTipText = "目录加载失败！"
        }
      )
    },
    // 处理子文件夹
    handleSubdir(subdir) {
      let tempData = subdir
      tempData.forEach((item, index) => {
        item = this.formatTreeNodeName(item)
        if (item.ChildFolders.length > 0) {
          item.ChildFolders = this.handleSubdir(item.ChildFolders)
        }
      })
      return tempData
    },
    //鼠标按下事件
    onBodyMouseDown(event) {
      if (!(event.target.id == "rMenu" || this.$refs.rMenu.contains(event.target))) {
        this.hideRMenu()
      }
    },
    //隐藏右键菜单
    hideRMenu() {
      let rMenu = this.$refs.rMenu
      if (rMenu) {
        rMenu.style.visibility = "hidden"
      } //设置右键菜单不可见
      document.removeEventListener("mousedown", this.onBodyMouseDown)
    },
    // 查看未读邮件
    viewUnread() {
      this.hideRMenu()
      let rNode = this.rightClickTreeNode
      // 设置目录为选中
      this.$refs.emailFolderTree.setCurrentKey(rNode.data.Id)
      // 跳转到指定列表页
      let query = {
        folderId: rNode.data.Id,
        level: rNode.level,
        DisplayName: encodeURIComponent(rNode.data.DisplayName),
        FolderType: rNode.data.FolderType,
        IsRead: "false"
      }
      this.$router.push({path: "/index", query})
    },
    //新建文件夹
    addFolder() {
      this.hideRMenu()
      this.$prompt(this.$t("foldername"), this.$t("createNewFolder"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        inputPattern: /\S/,
        inputErrorMessage: this.$t("pleaseEnterFolderName")
      })
        .then(({value}) => {
          let createData = {
            data: {
              DisplayName: value,
              ParentFolderId: this.rightClickTreeNode.data.Id
            }
          }
          this.$api.post(
            `/${this.$utils.getApiPrefix().exchangeapi}/folders/add`,
            createData,
            r => {
              if (r.Success === true) {
                // 创建成功
                this.$message({
                  type: "success",
                  message: this.$t("createSuc")
                })

                let rNode = this.rightClickTreeNode
                if (rNode.expanded) {
                  // 如果当前节点已经展开，则直接追加新节点
                  this.$refs.emailFolderTree.append(this.formatTreeNodeName(r.Data), rNode)
                } else {
                  // 如果当前节点是未展开的叶子节点或者是未展开的非叶子节点
                  // 则直接展开
                  if (rNode.isLeaf || !rNode.childNodes.length) {
                    this.rightClickTreeNode.expand()
                    this.expandNodeKeys[rNode.data.Id] = true
                    // 否则就是未展开的非叶子节点，但是有childNodes（也就是被展开过，又折叠起来的非叶子节点）
                  } else {
                    // 追加新节点
                    this.$refs.emailFolderTree.append(this.formatTreeNodeName(r.Data), rNode)
                    // 将节点展开
                    rNode.expanded = true
                  }
                }
              }
            },
            f => {
              let msg = "创建失败！"
              if (f.Message === "A folder with the specified name already exists.") {
                msg += "文件夹名称重复。"
              }
              this.$message({
                showClose: true,
                message: msg,
                type: "warning"
              })
            }
          )
        })
        .catch(() => {
          // 已取消
          this.$message({
            type: "info",
            message: this.$t("cancelled")
          })
        })
    },
    //重命名文件名
    editFolder() {
      this.hideRMenu()
      this.$prompt(this.$t("foldername"), this.$t("renameFolderName"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        inputPattern: /\S/,
        inputErrorMessage: this.$t("pleaseEnterFolderName"),
        inputValue: this.editFileName
      })
        .then(({value}) => {
          let createData = {
            data: {
              FolderId: this.rightClickTreeNode.data.Id,
              DisplayName: value,
              ParentFolderId: this.rightClickTreeNode.data.ParentFolderId
            }
          }
          this.$api.post(
            `/${this.$utils.getApiPrefix().exchangeapi}/folders/update`,
            createData,
            r => {
              if (r.Success === true) {
                // 修改成功
                this.$message({
                  type: "success",
                  message: this.$t("modifySuc")
                })
                let rNode = this.rightClickTreeNode
                // 重置节点为新数据
                rNode.setData(this.formatTreeNodeName(r.Data))
              }
            },
            f => {
              this.$message({
                showClose: true,
                message: "修改失败！(用户名不能重复！)",
                type: "warning"
              })
            }
          )
        })
        .catch(() => {
          // 已取消
          this.$message({
            type: "info",
            message: this.$t("cancelled")
          })
        })
    },
    //删除
    deleteFolder() {
      this.hideRMenu()
      let rNode = this.rightClickTreeNode
      let folderTree = this.$refs.emailFolderTree
      let DeleteMode = rNode.data.FolderType != 4 ? 2 : 0
      // 您确定要删除吗
      this.$confirm(this.$t("sureDel"), this.$t("tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning"
      })
        .then(() => {
          let createData = {
            data: {
              FolderId: rNode.data.Id,
              // 已删除目录用强制删除0，其他目录用移动删除2
              DeleteMode: DeleteMode,
              ParentFolderId: rNode.data.ParentFolderId
            }
          }
          this.$api.post(
            `/${this.$utils.getApiPrefix().exchangeapi}/folders/delete`,
            createData,
            r => {
              if (r.Success === true) {
                // 删除成功
                this.$message({
                  type: "success",
                  message: this.$t("delSuccess")
                })
                // 从树中移除当前节点
                folderTree.remove(rNode)
                // 如果显示的邮件列表是当前目录的邮件列表，则将页面返回首页
                if (rNode.data.Id === this.$route.query.folderId) {
                  this.treeNodeClick(this.inboxObj, {level: 1})
                }
                // 移动删除时将被删除的目录移动到 已删除 文件夹下
                if (DeleteMode === 2) {
                  // let deletedFolder = folderTree.getNode(this.deletedFolderId)
                  // 如果 已删除 目录没有展开，展开并设置 已删除 目录为非页子节点
                  // if (!deletedFolder.expanded) {
                  //   deletedFolder.isLeaf = false
                  //   deletedFolder.expand()
                  // }
                  // 从后台获取最新数据，因为删除后的目录Id会改变
                  this.getAllFolderFn()
                }
              }
            },
            f => {
              // 删除失败
              this.$message({
                showClose: true,
                message: this.$t("delFail"),
                type: "warning"
              })
            }
          )
        })
        .catch(() => {
          // 已取消
          this.$message({
            type: "info",
            message: this.$t("cancelled")
          })
        })
    },
    //清空文件夹
    clearFolder() {
      this.hideRMenu()
      // 您确定要清空文件夹吗
      this.$confirm(this.$t("sureEmptyFolder"), this.$t("tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("cancel"),
        type: "warning"
      })
        .then(() => {
          this.$api.axios(
            {
              url: `/${this.$utils.getApiPrefix().exchangeapi}/folder/id/empty`,
              method: "POST",
              data: {
                data: {
                  FolderId: this.rightClickTreeNode.data.Id,
                  DeleteMode: 0,
                  DeleteSubFolders: true
                }
              }
            },
            r => {
              if (r.Success === true) {
                // 清空成功
                this.$message({
                  type: "success",
                  message: this.$t("clearSuc")
                })
                let rNode = this.rightClickTreeNode
                // 将当前节点设为叶子节点，并删除子节点
                rNode.isLeaf = true
                rNode.childNodes = []
                //刷新邮件列表
                this.$root.$emit("refreshEmailList")
              }
            },
            f => {
              // 清空失败
              this.$message({
                showClose: true,
                message: this.$t("clearFail"),
                type: "warning"
              })
            }
          )
        })
        .catch(() => {
          // 已取消
          this.$message({
            type: "info",
            message: this.$t("cancelled")
          })
        })
    },
    //全部标记为已读
    markedFolder() {
      let rNode = this.rightClickTreeNode
      this.$api.axios(
        {
          url: `/${this.$utils.getApiPrefix().exchangeapi}/emails/folder/id/batch-read`,
          method: "PUT",
          data: {
            FolderId: rNode.data.Id,
            SetUnRead: false //true-标记未读;false-标记已读(默认false)
          }
        },
        r => {
          if (r.Success === true) {
            // 标记成功
            this.$message({
              type: "success",
              message: this.$t("markSuc")
            })
            // 去掉未读数提示，草稿箱除外，因为草稿箱是显示的总邮件数
            if (rNode.data.FolderType != 2) {
              rNode.data.name = rNode.data.DisplayName
            }
            if (rNode.data.FolderType === 1) {
              //收件箱未读数量处理
              // this.$root.$emit("syncFolderReadStatus", {
              //   actionType: "read",
              //   folderId: rNode.data.Id,
              //   mailNumber: rNode.data.UnreadCount
              // })
              // 刷新文件夹目录
              this.getAllFolderFn()
            }
            // 如果当前正在该目录邮件列表页面，则刷新列表页面更新未读状态
            let routerId = this.$route.query.folderId
            if (routerId && routerId === rNode.data.Id) {
              this.$root.$emit("reloadEmailList")
            }
          }
        },
        f => {
          // 标记失败
          this.$message({
            showClose: true,
            message: this.$t("markFail"),
            type: "warning"
          })
        }
      )
      this.hideRMenu()
    },
    // 写邮件
    writeEmail() {
      // 如果当前已经在写邮件页面则不跳转
      if (this.$route.name === "emailAdd") return
      this.$router.push({
        path: "/add",
        query: {etype: encodeURIComponent("新邮件"), eid: ""}
      })
    },
    // 新建会议
    newMeetingEmailFn() {
      this.$router.push({
        name: "AddMeeting",
        query: {etype: encodeURIComponent("新建会议"), eid: ""}
      })
    },
    // 重置规则-主题和收件人置空
    resetRule() {
      this.ruleSetInfo = {
        Subject: "",
        Sender: ""
      }
    },
    // 规则验证-主题和发件人都为空时返回false
    ruleVerify() {
      if (this.ruleSetInfo.Subject != "" || this.ruleSetInfo.Sender != "") {
        return true
      } else {
        this.$message({
          message: this.$t("subjectSenderLeastOne"), //主题和收件人至少填写一项
          type: "warning"
        })
        return false
      }
    },
    // 规则设置
    ruleSetFn(type) {
      this.hideRMenu()
      if (type == "取消") {
        this.ruleSetDialogVisibility = false
        this.resetRule()
      } else if (type == "确定") {
        if (!this.ruleVerify()) return
        this.$api.post(
          `/${this.$utils.getApiPrefix().exchangeapi}/rules`,
          {
            data: {
              Subject: this.ruleSetInfo.Subject ? [this.ruleSetInfo.Subject] : [],
              Sender: this.ruleSetInfo.Sender ? [this.ruleSetInfo.Sender] : [],
              FolderId: this.rightClickTreeNode.data.Id,
              RuleName: this.editFileName
            }
          },
          r => {
            if (r.Success == true) {
              // 设置成功
              this.$message({
                message: this.$t("setSuc"),
                type: "success"
              })
            }
            this.ruleSetDialogVisibility = false
            this.resetRule()
          },
          e => {
            // 设置失败
            this.$message({
              showClose: true,
              message: this.$t("setFail"),
              type: "warning"
            })
            this.ruleSetDialogVisibility = false
            this.resetRule()
          }
        )
      }
    },
    // 格式化树节点名称
    formatTreeNodeName(nodeData) {
      let temp = nodeData
      if (temp.UnreadCount > 0) {
        temp.name = temp.DisplayName + "(" + temp.UnreadCount + ")"
      } else {
        temp.name = temp.DisplayName
      }
      return temp
    },
    // 节点点击事件
    treeNodeClick(data, node, tree) {
      if (data.Id === "0") {
        // 跳转到目录列表页
        this.$router.push("/folder")
      } else {
        // 跳转到指定列表页
        let query = {
          folderId: data.Id,
          level: node.level,
          DisplayName: encodeURIComponent(data.DisplayName),
          FolderType: data.FolderType
        }
        this.$router.push({path: "index", query: query})
      }
    },
    // 节点展开事件
    treeNodeExpand(data, node, tree) {
      this.expandNodeKeys[data.Id] = true
    },
    // 节点折叠事件
    treeNodeCollapse(data, node, tree) {
      this.$delete(this.expandNodeKeys, data.Id)
    },
    // 节点右键事件
    treeNodeContextmenu(event, data, node, tree) {
      // 保存右键所在节点
      this.rightClickTreeNode = node
      this.editFileName = data.DisplayName
      let top = document.body.scrollTop
      //一级文件夹
      if (node.level === 1) {
        if (data.FolderType === 1) {
          //一级节点收件箱-没有清空文件夹的功能
          this.showContextmenu("inboxParent", event.clientX, event.clientY + top)
        } else {
          this.showContextmenu("root", event.clientX, event.clientY + top)
        }
      }
      //二级文件夹
      if (node.level === 2) {
        this.showContextmenu("firstNode", event.clientX, event.clientY + top) //处理位置，使用的是绝对位置
        if (data.FolderType === 1 && "内部邮件/未分类邮件".indexOf(data.DisplayName) != -1) {
          // 如果是收件箱下的'内部邮件/未分类邮件'目录
          this.showContextmenu("firstNodeRoots", event.clientX, event.clientY + top)
        }
        if (data.WellKnownFolderName === "Inbox") {
          //二级节点收件箱（inbox文件夹）-没有清空文件夹功能
          this.showContextmenu("inbox", event.clientX, event.clientY + top)
        }
      }
      //三级文件夹
      if (node.level === 3) {
        this.showContextmenu("secondNode", event.clientX, event.clientY + top) //处理位置，使用的是绝对位置
      }
    },
    // 显示右键菜单
    showContextmenu(type, x, y) {
      let rightMenu = this.$refs.rMenu
      /**
       * m_add - 新建文件夹
       * m_clear - 清空文件夹
       * m_marked - 全部标记为已读
       * m_unread - 查看未读
       * m_editFile - 重命名
       * m_delete - 删除
       * m_class - 分类设置
       * */
      if (type === "inboxParent") {
        this.rightMenuShowSet = {
          m_add: true,
          m_marked: false,
          m_unread: true,
          m_clear: false,
          m_editFile: false,
          m_delete: false,
          m_class: false
        }
      }
      if (type === "inbox") {
        this.rightMenuShowSet = {
          m_add: false,
          m_marked: true,
          m_unread: true,
          m_clear: true,
          m_editFile: false,
          m_delete: false,
          m_class: false
        }
      }
      if (type === "root") {
        this.rightMenuShowSet = {
          m_add: true,
          m_marked: true,
          m_unread: true,
          m_clear: true,
          m_editFile: false,
          m_delete: false,
          m_class: false
        }
      }
      if (type === "firstNodeRoots") {
        this.rightMenuShowSet = {
          m_add: true,
          m_marked: true,
          m_unread: true,
          m_clear: true,
          m_editFile: false,
          m_delete: false,
          m_class: true
        }
      }
      if (type === "firstNode") {
        this.rightMenuShowSet = {
          m_add: true,
          m_marked: true,
          m_unread: true,
          m_clear: true,
          m_editFile: true,
          m_delete: true,
          m_class: true
        }
      }
      if (type === "secondNode") {
        this.rightMenuShowSet = {
          m_add: false,
          m_marked: true,
          m_unread: true,
          m_clear: true,
          m_editFile: true,
          m_delete: true,
          m_class: true
        }
      }
      //需要包在nextTick里，不然获取不到最新的rightMenu元素高度
      this.$nextTick(() => {
        let bodyH = document.body.clientHeight,
          rightMenuH = rightMenu.clientHeight
        if (y + rightMenuH > bodyH) y = y - rightMenuH
        rightMenu.setAttribute("style", `top:${y}px; left:${x}px; visibility: visible;`)
      })
      //在当前页面绑定 鼠标事件
      document.addEventListener("mousedown", this.onBodyMouseDown)
    },

    /** 在列表上做了删除，标记已读未读时同步目录邮件数量提示
     * param: type {string} 类型：unread(处理未读数量)/total(处理总数)
     * param: folder {treeNode} 树菜单上的目录节点
     * param: mailNum {number} 要加减掉的邮件数量
     */
    syncFolderCountTip(folder, data) {
      let reg = /\((.+?)\)/g
      let mailNumber = folder.data.name.match(reg)
      // 从当前显示的目录名称中截取数量数据
      mailNumber ? (mailNumber = parseInt(mailNumber[0].slice(1, -1))) : (mailNumber = 0)
      if (data.actionType === "read") {
        // 标记为已读
        let unreadNum = mailNumber - data.mailNumber
        if (unreadNum > 0) {
          folder.data.name = `${folder.data.DisplayName}(${unreadNum})`
        } else {
          folder.data.name = folder.data.DisplayName
        }
        //未读数量减少
        updateInboxUnreadNum(this, -data.mailNumber)
      } else {
        // 标记为未读
        let unreadNum = mailNumber + data.mailNumber
        folder.data.name = `${folder.data.DisplayName}(${unreadNum})`
        //未读数量增加
        updateInboxUnreadNum(this, data.mailNumber)
      }

      function updateInboxUnreadNum(_this, num) {
        //收件箱有子文件夹时inboxId='0',收件箱没有子文件夹时inboxId="AQMkAGI3Y2Q......"
        // 收件箱没有子文件夹时num=0，否则收件箱未读数量会重复增加或减少
        if (_this.inboxId != "0") num = 0
        // 如果是收件箱目录，则更新inboxUnreadNum变量
        if (folder.data.FolderType === 1) {
          // 获取收件箱目录，同步提示;
          let inboxParentFloder = _this.$refs.emailFolderTree.getNode(_this.inboxId)
          let reg = /\((.+?)\)/g
          let mailNumber = inboxParentFloder.data.name.match(reg)
          // 从收件箱目录名称中截取数量数据
          mailNumber ? (mailNumber = parseInt(mailNumber[0].slice(1, -1))) : (mailNumber = 0)
          let inboxUnreadNum = mailNumber + num
          _this.inboxUnreadNum = inboxUnreadNum
          if (inboxUnreadNum > 0) {
            inboxParentFloder.data.name = `${inboxParentFloder.data.DisplayName}(${inboxUnreadNum})`
          } else {
            inboxParentFloder.data.name = inboxParentFloder.data.DisplayName
          }
        }
      }
    },

    // 弹出提示信息
    popNotification(msg) {
      // 非c3环境
      // 浏览器不支持消息推送时打断（已知ie不支持）
      if (!this.acceptNotification) return
      new Notification("提示", {
        body: `您有 ${msg} 封未读邮件，请注意查收！`,
        tag: "geely-email-notification",
        renotify: true,
        icon: NotificationIcon
      })
    },
   
    //日历相关===
    //选中某天
    choseDay(time) {
      //左侧小日历点击某天跳转到右侧视图对应时间
      this.$root.$emit("clickOneDay", time)
    },
    //左右点击切换月份
    changeMonth(time) {
      console.log(time)
      //左侧小日历切换月份后同步到右侧视图
      this.$root.$emit("smallClendarChangeMonthToView", time)
    },
    //跳到了本月
    clickToday(time) {
      console.log(time)
    },
    //写信、会议按钮---mousedown（c3环境）
    btnMousedown(type) {
      this.btnclick = type
    },
    //写信、会议按钮---mouseup（c3环境）
    btnMouseup() {
      this.btnclick = ""
    }
  },
  created() {
    // 获取文件夹数据
    this.getAllFolderFn("firstLoad")
    // 同步目录数量提示状态
    this.$root.$on("syncFolderReadStatus", data => {
      if (data) {
        let folderTree = this.$refs.emailFolderTree
        if (!folderTree) return

        let folder = folderTree.getNode(data.folderId)
        if (!folder) return

        // 更新未读数量提示
        this.syncFolderCountTip(folder, data)
      }
    })
    // 同步草稿箱目录数据提示状态
    this.$root.$on("syncDraftsFolderStatus", data => {
      if (data) {
        // 如果树目录还没创建，返回不做处理
        let folderTree = this.$refs.emailFolderTree
        if (!folderTree) return

        // 如果目录不是草稿箱根目录，返回不做处理
        if (data.folderId != this.draftsFolderId) return
        let folder = folderTree.getNode(this.draftsFolderId)
        let reg = /\((.+?)\)/g
        let mailNumber = folder.data.name.match(reg)
        // 从当前显示的目录名称中截取数量数据
        mailNumber ? (mailNumber = parseInt(mailNumber[0].slice(1, -1))) : (mailNumber = 0)
        mailNumber = mailNumber - data.mailNumber
        if (mailNumber > 0) {
          folder.data.name = `${folder.data.DisplayName}(${mailNumber})`
        }
      }
    })
  },
  mounted() {
    // 每隔3分钟重新刷新文件夹目录数据
    setInterval(() => {
      this.getAllFolderFn("polling")
    }, 60000 * 3)

    // 如果支持消息提醒功能
    if (window.Notification) {
      if (Notification.permission != "granted") {
        // 询问用户是否接收消息
        Notification.requestPermission(permission => {
          if (permission === "granted") {
            this.acceptNotification = true
          }
        })
      } else {
        this.acceptNotification = true
      }
    }
    //右侧视图时间改变后同步到左侧小日历
    this.$root.$on("viewTimeChangeToSmallClendar", val => {
      this.$refs.calendar.ChoseMonth(val, false)
    })
    //视图点击某一天后左侧小日历对应日期选中
    this.$root.$on("selectOneDay", val => {
      this.$refs.calendar.ChoseMonth(val, true)
    })
    //进入邮件
    this.$root.$on("enterEmail", val => {
      this.treeNodeClick(this.inboxObj, {level: 1})
    })
    //刷新左侧文件夹目录
    this.$root.$on("refreshFolders", val => {
      this.getAllFolderFn(val)
    })
  }
}
</script>
<style lang="scss" scoped>
.asideMain {
  // overflow-y: hidden;
  .el-tree {
    padding: 0 8px;
    /deep/ .el-tree-node > .el-tree-node__children {
      overflow: visible;
    }
  }
  /deep/ .el-tree-node__content {
    height: 35px;
    line-height: 35px;
    border-left: 3px solid transparent;
    box-sizing: border-box;
    > .el-tree-node__expand-icon {
      font-size: 12px;
      font-weight: bold;
    }
    .el-icon-caret-right:before {
      content: "\E604";
      color: #296ab4;
    }
    .el-icon-caret-bottom:before {
      content: "\E603";
      color: #296ab4;
    }
    > .el-tree-node__expand-icon.is-leaf:before {
      color: transparent !important;
    }
  }
  /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    // background-color: #cde1ff;
    color: #296ab4;
    border-left: 3px solid #296ab4;
    .el-icon-caret-right:before {
      content: "\E604";
      color: #296ab4;
    }
    .el-icon-caret-bottom:before {
      content: "\E603";
      color: #296ab4;
    }
  }
}
.asideMain .wBtn * {
  box-sizing: border-box;
}
.asideMain .wBtn {
  text-align: center;
  width: 180px;
  height: 30px;
  line-height: 30px;
  margin: 20px auto;
  font-size: 14px;
}
.asideMain .wBtn span {
  float: left;
  width: 50%;
  height: 100%;
  border: 1px solid #296ab4;
  color: #296ab4;
}
.asideMain .wBtn span:hover {
  background: #296ab4;
  color: #fff;
  cursor: pointer;
}
.asideMain .wBtn span:nth-of-type(1) {
  border-radius: 20px 0 0 20px;
  border-right: none;
}
.asideMain .wBtn span:nth-of-type(2) {
  border-radius: 0 20px 20px 0;
}
/*邮件菜单样式*/
div#rMenu {
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.25);
  background: #fff;
  z-index: 1000;
  position: fixed;
  /*width: 100px;*/
  visibility: hidden;
  top: 0;
  padding: 1px;
}

div#rMenu ul li {
  font-size: 12px;
  line-height: 20px;
  padding: 5px 10px;
  cursor: pointer;
}

div#rMenu ul li:hover {
  background: #f0f6fc;
}

/**/

.el-dialog__header {
  background-image: linear-gradient(225deg, #48b1e5, #2d74bb);
}
/**/
.writeEmail:hover {
  color: #a4bfdd;
}
.newMeetingEmailFn:hover {
  color: #a4bfdd;
}
</style>


// WEBPACK FOOTER //
// src/components/aside.vue